import React from 'react';
import { render } from 'react-dom';
import { createBrowserHistory } from 'history';
import { Context, Readiness } from './shared';
import { initApplicationRoot } from './index';
import { DocumentShim } from './document';

const history = createBrowserHistory();

const readinessShim = new Readiness();

readinessShim.future.mapError(error => {
  console.warn('Error while initialising app (possibly expected):', error);
});

const { rootElem } = initApplicationRoot({ history });

const elemWithContext = (
  <Context readiness={readinessShim} history={history} window={window} document={document}>
    <DocumentShim>{rootElem}</DocumentShim>
  </Context>
);

render(elemWithContext, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/browser-main.js